import type {SidebarLink} from '@github-ui/saved-views'

export const repoSidebarLinks: SidebarLink[] = [
  {
    id: 'issues',
    name: 'Issues',
    searchType: 'issues',
    query: 'is:issue state:open',
    icon: 'issue_opened',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'assigned-to-me',
    name: 'Assigned to me',
    searchType: 'issues',
    query: 'is:issue state:open assignee:@me',
    icon: 'people',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'created-by-me',
    name: 'Created by me',
    searchType: 'issues',
    query: 'is:issue state:open author:@me',
    icon: 'smiley',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'mentioned',
    name: 'Mentioned',
    searchType: 'issues',
    query: 'is:issue state:open mentions:@me',
    icon: 'mention',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'recent-activity',
    name: 'Recent activity',
    searchType: 'issues',
    query: 'is:issue involves:@me updated:>@today-1w',
    icon: 'clock',
    color: 'gray',
    source: 'predefined',
  },
]
